import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmitEventOnEnter } from './EmitEventOnEnter.directive';

@NgModule({
  declarations: [ EmitEventOnEnter ],
  imports: [
    CommonModule
  ],
  exports: [ EmitEventOnEnter ]
})
export class SharedModule { }
